var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryCloudFinancialManagement32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/AWS-Cost-Management_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/AWS-Cost-Management_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-3",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Cost-Management_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,27 L16,27 L16,26 L13,26 L13,27 Z M8,27 L11,27 L11,26 L8,26 L8,27 Z M13,24 L16,24 L16,23 L13,23 L13,24 Z M8,24 L11,24 L11,23 L8,23 L8,24 Z M13,20 L16,20 L16,19 L13,19 L13,20 Z M8,20 L11,20 L11,19 L8,19 L8,20 Z M20,26 L23,26 L23,20 L20,20 L20,26 Z M23.5,19 L19.5,19 C19.224,19 19,19.224 19,19.5 L19,26.5 C19,26.776 19.224,27 19.5,27 L23.5,27 C23.776,27 24,26.776 24,26.5 L24,19.5 C24,19.224 23.776,19 23.5,19 L23.5,19 Z M9,16 L23,16 L23,13 L9,13 L9,16 Z M8.5,12 C8.224,12 8,12.224 8,12.5 L8,16.5 C8,16.776 8.224,17 8.5,17 L23.5,17 C23.776,17 24,16.776 24,16.5 L24,12.5 C24,12.224 23.776,12 23.5,12 L8.5,12 Z M27,29 L5,29 L5,10 L11,10 L11,10.5 C11,10.776 11.224,11 11.5,11 L19.5,11 C19.771,11 19.993,10.784 20,10.512 L20.013,10 L27,10 L27,29 Z M11.587,3 L17.5,3 C18.708,3 19.139,3.976 19.139,4.877 L19.013,10 L12,10 L12,9 L12,4.5 C12,3.867 11.842,3.375 11.587,3 L11.587,3 Z M8,6 L8,4.5 C8,3.464 8.753,3 9.5,3 C10.061,3 11,3.195 11,4.5 L11,6 L8,6 Z M27.5,9 L20.037,9 L20.139,4.89 C20.139,3.161 19.078,2 17.5,2 L10,2 L10,2.042 C8.56,1.798 7,2.643 7,4.5 L7,6.5 C7,6.776 7.224,7 7.5,7 L11,7 L11,9 L4.5,9 C4.224,9 4,9.224 4,9.5 L4,29.5 C4,29.776 4.224,30 4.5,30 L27.5,30 C27.776,30 28,29.776 28,29.5 L28,9.5 C28,9.224 27.776,9 27.5,9 L27.5,9 Z",
    id: "Fill-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryCloudFinancialManagement32);
export default __webpack_public_path__ + "static/media/Arch-Category_Cloud-Financial-Management_32.a8c6748dfa2d8490d2b305cbcaebee79.svg";
export { ForwardRef as ReactComponent };